import { Box, Button, theme } from '@dtx-company/design-system/src'
import { Star } from '@mui/icons-material'
import { ThemeProvider } from '@mui/material'
import { UPGRADE_UPSELL_COLOR, UPGRAGE_UPSELL_HOVER_COLOR } from '../constants'
import React from 'react'

interface UpgradeButtonProps {
  onClick: () => void
  hideIcon?: boolean
  size?: 'small' | 'medium' | 'large'
}
export const UpgradeButton: React.FC<UpgradeButtonProps> = ({
  onClick,
  hideIcon = false,
  size = 'medium',
  ...rest
}) => {
  const upsellButtonTheme = {
    ...theme,
    palette: {
      ...theme.palette,
      secondary: { ...theme.palette.secondary, main: UPGRADE_UPSELL_COLOR }
    }
  }
  return (
    <ThemeProvider theme={upsellButtonTheme}>
      <Box
        sx={{
          width: '100%',
          '& .MuiButton-root:hover': { backgroundColor: UPGRAGE_UPSELL_HOVER_COLOR },
          '.MuiBuutton-root:focus': { backgroundColor: UPGRAGE_UPSELL_HOVER_COLOR },
          ...rest
        }}
      >
        <Button
          size={size}
          startIcon={hideIcon ? undefined : Star}
          fullWidth
          color="secondary"
          onClick={e => {
            onClick()
            e.currentTarget.blur()
          }}
        >
          Upgrade
        </Button>
      </Box>
    </ThemeProvider>
  )
}
